import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import SoundExperience from "./components/SoundExperience";
import FlipAnimation from "./components/FlipAnimation";
import HotComics from "./components/HotComics";
import Categories from "./components/Categories";
import Brand from "./components/Brand";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!visible) return null;
  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <SoundExperience />
        <FlipAnimation />
        <HotComics />
        <Categories />
        <Brand />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default Home;